import { SitecoreDictionaryItem, SitecoreDictionaryPhrase } from 'common/types/sitecore';

export function getSharedDictionary<
  T extends Record<
    K,
    { value?: unknown } | { jsonValue: SitecoreDictionaryItem; fields: SitecoreDictionaryPhrase }
  >,
  K extends keyof T,
>(fields: T, fieldName: K): T[K] | undefined {
  const field = fields?.[fieldName];

  if (field && 'value' in field && field.value) {
    return field;
  }

  const sharedString = `${fieldName as string}Shared` as keyof T;
  const dictionaryString = `${fieldName as string}Dictionary` as keyof T;
  const sharedField = fields?.[sharedString] ?? fields?.[dictionaryString] ?? fields?.[fieldName];

  if (typeof sharedField === 'string') {
    console.error(
      `ERROR reading shared field ${sharedString.toString()}. Got only ID instead of value. Probably orphaned reference or indexing issue`
    );
    return undefined;
  }
  if (sharedField && 'fields' in sharedField) {
    const phrase = sharedField.fields?.Phrase;
    const phraseShared = sharedField.fields?.PhraseShared;

    if (phrase?.value || phraseShared?.value) {
      return {
        ...sharedField,
        value: phrase?.value || phraseShared?.value || '',
      } as unknown as T[K];
    }
  }

  if (sharedField && 'jsonValue' in sharedField) {
    const jsonValueField = sharedField.jsonValue;

    const phrase = jsonValueField?.fields?.Phrase;
    const phraseShared = jsonValueField?.fields?.PhraseShared;

    if (phrase?.value || phraseShared?.value) {
      return {
        ...sharedField,
        value: phrase?.value || phraseShared?.value || '',
      } as unknown as T[K];
    }
  }

  return undefined;
}

export function getDictionaryValue(
  field: SitecoreDictionaryItem | { jsonValue: SitecoreDictionaryItem }
): string {
  const targetField = 'jsonValue' in field ? field.jsonValue : field;

  return (targetField?.fields?.Phrase ?? targetField?.fields?.PhraseShared)?.value ?? '';
}
